import i18n from '@/languages/i18n';

const FormErrorMessage = {
  Required: i18n.t('VALIDATE_REQUIRED'),
  PhoneNumberErrorMessage: i18n.t('PHONE_NUMBER_INVALID'),
  EmailErrorMessage: i18n.t('EMAIL_INVALID'),
  PasswordInvalid: i18n.t('PASSWORD_INVALID'),
  RomanjiCharacter: i18n.t('INPUT_ROMANJI_CHAR'),
};

export default FormErrorMessage;
